// extracted by mini-css-extract-plugin
export default {"associates":"associates_associates__zMmgP","slider":"associates_slider__rkc1W","scroll":"associates_scroll__O51yg"};